
import React from 'react';
import styles from './AiGeneratedBadge.module.scss';
import { ReactComponent as IconSparkleAI } from "assets/icons/sparkle-ai.svg";
export const AiGeneratedBadge: React.FC = () => {
    return (
        <label className={styles.badge}>
            <IconSparkleAI />
            AI-GENERATED
        </label>
    );
};